import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { baseApiUrl } from "../../services/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import {
  Table,
  Modal,
  Button,
  notification,
  Input,
  Switch,
  Row,
  Col,
} from "antd";

import axios from "axios";

const Utilisateurs = () => {
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [photo, setPhoto] = useState("");
  const [siteWeb, setSiteWeb] = useState("");
  const [roles, setRoles] = useState([]);
  const [mdp, setMdp] = useState("");
  const [email, setEmail] = useState("");
  const [roleId, setRoleId] = useState("");
  const [idUtilisateur, setIdUtilisateur] = useState(null);
  const [dateDeNaissance, setDateDeNaissance] = useState("");
  const [adresse, setAdresse] = useState({
    adresse1: "",
    adresse2: "",
    ville: "",
    codePostale: "",
    pays: "",
  });
  const [utilisateurs, setUtilisateurs] = useState([]);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [viewingCategory, setViewingCategory] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deletingUser, setDeleteUser] = useState(null);

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await baseApiUrl.get("/role/liste");
        console.log("roles recuperé:", response);
        setRoles(response.data);
      } catch (error) {
        console.error("Erreur lors du chargement des rôles", error);
      }
    };

    fetchRoles();
    fetchUtilisateurs();
  }, []);

  const fetchUtilisateurs = async () => {
    try {
      const response = await baseApiUrl.get("/utilisateur");
      console.log("user recuperé:", response);
      setUtilisateurs(response.data);
    } catch (error) {
      console.error("Erreur lors du chargement des user", error);
    }
  };

  const handleAddUtilisateur = async (e) => {
    e.preventDefault();

    try {
      console.log("Début de la fonction handleAddUtilisateur");

      const formData = new FormData();
      const utilisateurData = {
        nom,
        prenom,
        siteWeb,
        mdp,
        email,
        roleId,
        dateDeNaissance,
        adresse,
      };

      console.log("Données utilisateur:", utilisateurData);
      formData.append(
        "utilisateur",
        new Blob([JSON.stringify(utilisateurData)], {
          type: "application/json",
        })
      );

      if (photo) {
        console.log("Photo ajoutée:", photo);
        formData.append("image", photo);
      }

      const response = await baseApiUrl.post("/utilisateur/create", formData);
      console.log("Réponse de l'API:", response);

      if (response.status === 200 || response.status === 201) {
        openNotificationWithIcon("success", "Utilisateur ajouté avec succès.");
        fetchUtilisateurs();
        setIsAddModalVisible(false);
      } else {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

    } catch (error) {
      openNotificationWithIcon(
        "error",
        "Erreur lors de l'ajout de l'utilisateur."
      );
      console.error("Erreur détectée:", error.message || error);
    }

    resetForm();
  };

  const handleEditUtilisateur = async (idUtilisateur, e) => {
    e.preventDefault();

    if (!idUtilisateur) {
      openNotificationWithIcon("error", "ID utilisateur manquant");
      return;
    }

    try {
      console.log("Début de la fonction handleEditUtilisateur");
      console.log("ID utilisateur:", idUtilisateur);

      const formData = new FormData();
      const utilisateurData = {
        nom,
        prenom,
        siteWeb,
        mdp,
        email,
        roleId,
        dateDeNaissance,
        adresse,
      };

      console.log("Données utilisateur pour mise à jour:", utilisateurData);
      formData.append(
        "utilisateur",
        new Blob([JSON.stringify(utilisateurData)], {
          type: "application/json",
        })
      );

      if (photo && photo instanceof File) {
        console.log("Photo ajoutée:", photo);
        formData.append("image", photo);
      }

      const response = await baseApiUrl.put(
        `/utilisateur/modifier/${idUtilisateur}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      console.log("Réponse de l'API pour mise à jour:", response);

      if (response.status === 200 || response.status === 201 || response.status === 204) {
        openNotificationWithIcon("success", "Utilisateur mis à jour avec succès.");
        fetchUtilisateurs();
        setIsEditModalVisible(false);
      } else {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

    } catch (error) {
      console.error("Erreur lors de la mise à jour:", error);
      openNotificationWithIcon(
        "error",
        "Erreur lors de la mise à jour de l'utilisateur."
      );
    }

    resetForm();
  };


  // Fonction pour confirmer la suppression
  const confirmDelete = async () => {
    if (!deletingUser) return;

    try {
      // Vérifier si l'utilisateur peut être supprimé
      const canBeDeleted = await checkUserCanBeDeleted(deletingUser.id);

      if (!canBeDeleted) {
        openNotificationWithIcon("error", "Cet utilisateur ne peut pas être supprimé car il est lié à d'autres données.");
        setIsDeleteModalVisible(false);
        setDeleteUser(null);
        return;
      }

      const response = await baseApiUrl.delete(`/utilisateur/${deletingUser.id}`);

      if (response.status === 200 || response.status === 204) {
        openNotificationWithIcon("success", "Utilisateur supprimé avec succès.");
        fetchUtilisateurs();
      } else {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la suppression:", error);
      openNotificationWithIcon("error", "Erreur lors de la suppression de l'utilisateur.");
    }

    setIsDeleteModalVisible(false);
    setDeleteUser(null);
  };
 // Fonction pour vérifier si un utilisateur peut être supprimé
  const checkUserCanBeDeleted = async (userId) => {
    try {
      const response = await baseApiUrl.get(`/utilisateur/check-deletion/${userId}`);
      return response.data.canBeDeleted;
    } catch (error) {
      console.error("Erreur lors de la vérification:", error);
      return false;
    }
  };

  const resetForm = () => {
    setNom("");
    setPrenom("");
    setAdresse({
      adresse1: "",
      adresse2: "",
      ville: "",
      codePostale: "",
      pays: "",
    });
    setSiteWeb("");
    setMdp("");
    setEmail("");
    setRoleId("");
    setDateDeNaissance("");
    setPhoto("");
    setIdUtilisateur(null);
    setEditingCategory(null);
    setIsAddModalVisible(false);
    setIsEditModalVisible(false);
    setIsViewModalVisible(false);
  };

  const handleEdit = (user) => {
    setEditingCategory(user);
    setIdUtilisateur(user.id);
    setNom(user.nom);
    setPrenom(user.prenom);
    setSiteWeb(user.siteWeb);
    setMdp(user.mdp);
    setEmail(user.email);
    setRoleId(user.roleId);
    setDateDeNaissance(user.dateDeNaissance);
    setAdresse(user.adresse || {
      adresse1: "",
      adresse2: "",
      ville: "",
      codePostale: "",
      pays: "",
    });
    setIsEditModalVisible(true);
  };

  const handleDeleteConfirm = (user) => {
    setDeleteUser(user);
    setIsDeleteModalVisible(true);
  };

  const handleView = (user) => {
    setViewingCategory(user);
    setIsViewModalVisible(true);
  };

  const filteredUtilisateurs = Array.isArray(utilisateurs)
    ? utilisateurs.filter(
        (utilisateur) =>
          utilisateur.nom &&
          utilisateur.nom.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];


  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-auto">
                <h3 className="page-title">Utilisateurs</h3>
                <div className="top-nav-search">
                  <input
                    className="form-control"
                    placeholder="Rechercher par nom"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-sm-5 col">
                <Button
                  type="primary"
                  onClick={() => setIsAddModalVisible(true)}
                  className="float-end mt-2 btn-success"
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                  Ajouter
                </Button>
              </div>
            </div>
          </div>

          <Table
            rowKey="id"
            columns={[
              { title: "Nom", dataIndex: "nom", key: "nom" },
              { title: "Prenom", dataIndex: "prenom", key: "prenom" },
              {
                title: "Etat",
                dataIndex: "actif",
                key: "actif",
                render: (actif, record) => (
                  <Switch
                    checked={actif}
                    onChange={(checked) =>
                      handleStatusChange(record.id, checked)
                    }
                  />
                ),
              },
              {
                title: "Role",
                dataIndex: "roleId",
                key: "roleId",
                render: (text, record) => (
                  <span>
                    {roles.find((role) => role.id === record.roleId)
                      ?.libelle || "N/A"}
                  </span>
                ),
              },
              {
                title: "Visibilité",
                dataIndex: "online",
                key: "online",
                render: (online) => (
                  <span style={{ color: online ? "green" : "red" }}>
                    {online ? "En ligne" : "Hors ligne"}
                  </span>
                ),
              },
              {
                title: "Photo",
                dataIndex: "photo",
                key: "photo",
                render: (imageName) => {
                  const imageUrl =
                    baseApiUrl.defaults.baseURL + `/image/${imageName}`;
                  return (
                    <img
                      src={imageUrl}
                      alt="user"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  );
                },
              },
              {
                title: "Actions",
                key: "actions",
                render: (text, record) => (
                  <div className="text-end">
                    <Button
                      className="ms-2 btn btn-sm bg-success-light"
                      onClick={() => handleView(record)}
                    >
                      Voir
                    </Button>
                    <Button
                      className="ms-2 btn btn-sm bg-primary-light"
                      onClick={() => handleEdit(record)}
                    >
                      Modifier
                    </Button>
                    <Button
                      className="ms-2 btn btn-sm bg-danger-light"
                      onClick={() => handleDeleteConfirm(record)}
                    >
                      Supprimer
                    </Button>
                  </div>
                ),
              },
            ]}
            dataSource={filteredUtilisateurs}
          />

          {/* Modal d'ajout */}
          <Modal
            title="Ajouter un utilisateur"
            open={isAddModalVisible}
            onCancel={() => setIsAddModalVisible(false)}
            footer={[
              <Button key="back" onClick={() => setIsAddModalVisible(false)}>
                Annuler
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={handleAddUtilisateur}
              >
                Ajouter
              </Button>,
            ]}
            width={800}
          >
            <form onSubmit={handleAddUtilisateur}>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Nom</label>
                    <input
                      type="text"
                      className="form-control"
                      value={nom}
                      onChange={(e) => setNom(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Prenom</label>
                    <input
                      type="text"
                      className="form-control"
                      value={prenom}
                      onChange={(e) => setPrenom(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Adresse 1</label>
                    <input
                      type="text"
                      className="form-control"
                      value={adresse.adresse1}
                      onChange={(e) =>
                        setAdresse({ ...adresse, adresse1: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Adresse 2</label>
                    <input
                      type="text"
                      className="form-control"
                      value={adresse.adresse2}
                      onChange={(e) =>
                        setAdresse({ ...adresse, adresse2: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Pays</label>
                    <input
                      type="text"
                      className="form-control"
                      value={adresse.pays}
                      onChange={(e) =>
                        setAdresse({ ...adresse, pays: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Ville</label>
                    <input
                      type="text"
                      className="form-control"
                      value={adresse.ville}
                      onChange={(e) =>
                        setAdresse({ ...adresse, ville: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Code postal</label>
                    <input
                      type="text"
                      className="form-control"
                      value={adresse.codePostale}
                      onChange={(e) =>
                        setAdresse({ ...adresse, codePostale: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Role</label>
                    <select
                      className="form-control"
                      value={roleId || ""}
                      onChange={(e) => setRoleId(e.target.value)}
                    >
                      <option value="">Sélectionnez un rôle</option>
                      {roles.map((r) => (
                        <option key={r.id} value={r.id}>
                          {r.libelle}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Mot de passe</label>
                    <input
                      type="password"
                      className="form-control"
                      value={mdp}
                      onChange={(e) => setMdp(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Date de naissance</label>
                    <input
                      type="date"
                      className="form-control"
                      value={dateDeNaissance}
                      onChange={(e) => setDateDeNaissance(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Photo</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => setPhoto(e.target.files[0])}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-12">
                  <div className="form-group">
                    <label>Lien site web</label>
                    <input
                      type="url"
                      className="form-control"
                      value={siteWeb}
                      onChange={(e) => setSiteWeb(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </form>
          </Modal>

          {/* Modal de modification */}
          <Modal
            title="Modifier l'utilisateur"
            open={isEditModalVisible}
            onCancel={() => setIsEditModalVisible(false)}
            footer={[
              <Button key="back" onClick={() => setIsEditModalVisible(false)}>
                Annuler
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={(e) => handleEditUtilisateur(editingCategory?.id, e)}
              >
                Enregistrer les modifications
              </Button>,
            ]}
            width={800}
          >
            <form onSubmit={(e) => handleEditUtilisateur(editingCategory?.id, e)}>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Nom</label>
                    <input
                      type="text"
                      className="form-control"
                      value={nom}
                      onChange={(e) => setNom(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Prenom</label>
                    <input
                      type="text"
                      className="form-control"
                      value={prenom}
                      onChange={(e) => setPrenom(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Adresse 1</label>
                    <input
                      type="text"
                      className="form-control"
                      value={adresse.adresse1}
                      onChange={(e) =>
                        setAdresse({ ...adresse, adresse1: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Adresse 2</label>
                    <input
                      type="text"
                      className="form-control"
                      value={adresse.adresse2}
                      onChange={(e) =>
                        setAdresse({ ...adresse, adresse2: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Pays</label>
                    <input
                      type="text"
                      className="form-control"
                      value={adresse.pays}
                      onChange={(e) =>
                        setAdresse({ ...adresse, pays: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Ville</label>
                    <input
                      type="text"
                      className="form-control"
                      value={adresse.ville}
                      onChange={(e) =>
                        setAdresse({ ...adresse, ville: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Code postal</label>
                    <input
                      type="text"
                      className="form-control"
                      value={adresse.codePostale}
                      onChange={(e) =>
                        setAdresse({ ...adresse, codePostale: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Role</label>
                    <select
                      className="form-control"
                      value={roleId || ""}
                      onChange={(e) => setRoleId(e.target.value)}
                    >
                      <option value="">Sélectionnez un rôle</option>
                      {roles.map((r) => (
                        <option key={r.id} value={r.id}>
                          {r.libelle}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Mot de passe</label>
                    <input
                      type="password"
                      className="form-control"
                      value={mdp}
                      onChange={(e) => setMdp(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Date de naissance</label>
                    <input
                      type="date"
                      className="form-control"
                      value={dateDeNaissance}
                      onChange={(e) => setDateDeNaissance(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Photo</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => setPhoto(e.target.files[0])}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-12">
                  <div className="form-group">
                    <label>Lien site web</label>
                    <input
                      type="url"
                      className="form-control"
                      value={siteWeb}
                      onChange={(e) => setSiteWeb(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </form>
          </Modal>

          {/* Modal pour afficher les détails complets de l'utilisateur */}
          <Modal
            title="Détails de l'utilisateur"
            open={isViewModalVisible}
            onCancel={() => setIsViewModalVisible(false)}
            footer={[
              <Button key="close" onClick={() => setIsViewModalVisible(false)}>
                Fermer
              </Button>,
            ]}
            width={600}
          >
            {viewingCategory && (
              <div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <img
                      src={baseApiUrl.defaults.baseURL + `/image/${viewingCategory.photo}`}
                      alt="Photo utilisateur"
                      style={{
                        width: "100%",
                        maxWidth: "150px",
                        height: "150px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div className="col-md-8">
                    <h4>{viewingCategory.nom} {viewingCategory.prenom}</h4>
                    <p><strong>Email:</strong> {viewingCategory.email}</p>
                    <p><strong>Rôle:</strong> {roles.find(role => role.id === viewingCategory.roleId)?.libelle || "N/A"}</p>
                    <p><strong>Statut:</strong>
                      <span style={{ color: viewingCategory.actif ? "green" : "red" }}>
                        {viewingCategory.actif ? " Actif" : " Inactif"}
                      </span>
                    </p>
                    <p><strong>Visibilité:</strong>
                      <span style={{ color: viewingCategory.online ? "green" : "red" }}>
                        {viewingCategory.online ? " En ligne" : " Hors ligne"}
                      </span>
                    </p>
                  </div>
                </div>

               <div className="mb-3">
                  <h5>Informations personnelles</h5>
                  <p><strong>Date de naissance:</strong> {viewingCategory.dateDeNaissance || "Non renseignée"}</p>
                  <p><strong>Site web:</strong>
                    {viewingCategory.siteWeb ?
                      <a href={viewingCategory.siteWeb} target="_blank" rel="noopener noreferrer">
                        {viewingCategory.siteWeb}
                      </a> : "Non renseigné"
                    }
                  </p>
                </div>

                <div className="mb-3">
                  <h5>Adresse</h5>
                  <p><strong>Adresse 1:</strong> {viewingCategory.adresse?.adresse1 || "Non renseignée"}</p>
                  <p><strong>Adresse 2:</strong> {viewingCategory.adresse?.adresse2 || "Non renseignée"}</p>
                  <p><strong>Ville:</strong> {viewingCategory.adresse?.ville || "Non renseignée"}</p>
               <p><strong>Code postal:</strong> {viewingCategory.adresse?.codePostale || "Non renseigné"}</p>
                  <p><strong>Pays:</strong> {viewingCategory.adresse?.pays || "Non renseigné"}</p>
                </div>

                <div className="mb-3">
                  <h5>Dates importantes</h5>
                  <p><strong>Date de création:</strong> {viewingCategory.dateCreation ? new Date(viewingCategory.dateCreation).toLocaleDateString() : "Non disponible"}</p>
                  <p><strong>Dernière modification:</strong> {viewingCategory.dateModification ? new Date(viewingCategory.dateModification).toLocaleDateString() : "Non disponible"}</p>
                  <p><strong>Dernière connexion:</strong> {viewingCategory.derniereConnexion ? new Date(viewingCategory.derniereConnexion).toLocaleDateString() : "Jamais connecté"}</p>
                </div>
              </div>
            )}
          </Modal>

          {/* Modal de confirmation de suppression */}
          <Modal
            title="Confirmer la suppression"
            open={isDeleteModalVisible}
            onOk={confirmDelete}
            onCancel={() => {
              setIsDeleteModalVisible(false);
              setDeleteUser(null);
            }}
            okText="Supprimer"
            cancelText="Annuler"
            okButtonProps={{ danger: true }}
          >
            <p>Êtes-vous sûr de vouloir supprimer cet utilisateur ?</p>
            <p><strong>Nom:</strong> {deletingUser?.nom} {deletingUser?.prenom}</p>
            <p><strong>Email:</strong> {deletingUser?.email}</p>
            <p style={{ color: 'red', fontWeight: 'bold' }}>
              Cette action est irréversible !
            </p>
          </Modal>
        </div>
      </div>
     </>

  );
};

export default Utilisateurs;
